import { Button, Flex, Text } from '@chakra-ui/react';
import { PeOrderOperationType } from 'enums/modules/pe/peOperationType';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import AppCard from 'presentation/components/shared/card/AppCard';
import { ButtonVariant } from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

const PeCompanyStockActionCard: FC<PeCompanyDetail> = ({
  price,
  currency,
  id,
  name,
}) => {
  const { t } = useTranslation();

  const currencyText = useCurrencyText();

  const navigate = useNavigate();

  const goToCreatePeOrder = (operationType: PeOrderOperationType): void => {
    navigate(
      AppRoute.createPeCompanyOrder(id, {
        operation_type: operationType,
        company_name: name,
        requested_price: price,
        company_currency: currency.symbol,
      })
    );
  };

  return (
    <AppCard p="15px">
      <Text mb="10px">{t('peCompanySharesPrice')}</Text>
      <Text fontSize="30px" mb="10px" fontWeight={700}>
        {currencyText(price, { symbol: currency.symbol })}
      </Text>
      <Flex>
      <Button
          onClick={() => goToCreatePeOrder(PeOrderOperationType.Sell)}
          flex="1"
          mr="15px"
          variant={ButtonVariant.Secondary}
        >
          {t('sell')}
        </Button>
        <Button
          onClick={() => goToCreatePeOrder(PeOrderOperationType.Buy)}
          flex="1"
        >
          {t('buy')}
        </Button>
      </Flex>
    </AppCard>
  );
};

export default PeCompanyStockActionCard;
